// Hämtar info från om bil från kobra
import { getFacilities } from '../general.js';
import debounce from './debouncer.js';

let val;

export default async function getInfoFromReg(val){
    let type;

    if(val.length >= 6 && val.length <= 7) {
        const form = new FormData();
        form.append('action', 'nobox_get_car');
        form.append('regno', val);
        form.append('mileage', 1000);
        const obj = getFacilities();
        form.append('key', obj[Object.keys(obj)[0]].key); // Hämtar nyckeln från första anläggningen i listan
        const params = new URLSearchParams(form);

        let info;
        await fetch(horizon.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: params,
        })
        .then(response => response.json())
        .then(data => {
            let resp = JSON.parse(data.data);
            if((typeof resp === 'string' || resp instanceof String) && resp && resp !== "") {
                info = resp;
            } else if(resp && resp !== "") {
                info = resp;
                info.regno = val;
            } else if(data.errors && data.errors.length > 0) {
                info = data.errors[0];
            } else {
                info = "Något gick fel, vänligen testa ett annat regnummer eller kontakta oss."
            }
        })
        .then(async data => {
            if(info.model && info.model !== "") {
                const f = new FormData();
                f.append('action', 'nobox_get_car_type');
                f.append('model', info.model);
                const p = new URLSearchParams(f);
                await fetch(horizon.ajaxUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                    },
                    body: p,
                })
                .then(response => response.json())
                .then(resp => {
                    if(resp.data && resp.data != "") {
                        info.type = resp.data;
                    } else if(resp.errors && resp.errors.length > 0) {
                        info = resp.errors[0];
                    } else {
                        info = "Något gick fel, vänligen testa ett annat regnummer eller kontakta oss."
                    }
                })
            }
        })

        return info;
    }
}

